// Build My Routine scoring and hard filters.
// Loaded after classification and before build-my-routine.js.

function matchRoutinePreference(productPreference, selectedPreference) {
  if (!productPreference || !selectedPreference) return true;
  if (productPreference === selectedPreference) return true;

  if (productPreference === 'am_plus_pm' && (selectedPreference === 'am_only' || selectedPreference === 'pm_only')) {
    return true;
  }

  if (selectedPreference === 'am_plus_pm' && (productPreference === 'am_only' || productPreference === 'pm_only')) {
    return true;
  }

  return false;
}

function passesFitzpatrickFilter(product) {
  if (!state.fitzpatrick) return true;

  // Blank Fitzpatrick means universal / not restricted.
  if (!product.fitzpatrick || !product.fitzpatrick.length) return true;

  return product.fitzpatrick.includes(state.fitzpatrick);
}

function passesAgeFilter(product) {
  const expectedLabel = AGE_BUTTON_TO_LABEL[state.age];
  if (!expectedLabel) return true;

  const productType = normalizeValue(product.type);
  const productTypeMeta = normalizeValue(product.product_type_meta);

  // Body-wash style products are only allowed in paediatric mode.
  // Adult/teen routines should stay face-care focused.
  if (
    state.age !== '0-12' &&
    (
      productType === 'body_wash' ||
      productTypeMeta === 'body_wash' ||
      productType === 'bath_and_shower' ||
      productTypeMeta === 'bath_and_shower'
    )
  ) {
    return false;
  }

  if (!product.age_category_labels || !product.age_category_labels.length) return false;
  return product.age_category_labels.includes(expectedLabel);
}

function passesTreatmentFilter(product) {
  const treatmentFilterValues = [
    normalizeValue('Chemical peels'),
    normalizeValue('Laser / IPL'),
    normalizeValue('Microneedling')
  ];

  const filterTreatments = (state.treatments || []).filter((treatment) =>
    treatmentFilterValues.includes(treatment)
  );

  if (!filterTreatments.length) return true;

  const productTreatments = splitListValues(product.aesthetic_treatments || [])
    .map(normalizeValue)
    .filter(Boolean);

  if (!productTreatments.length) return false;

  return filterTreatments.every((treatment) =>
    productTreatments.includes(treatment)
  );
}

function passesTopicalSteroidFilter(product) {
  if (state.topical_steroid_use !== 'yes') return true;
  return product.topical_steroid_safe;
}

function passesIsotretinoinFilter(product) {
  if (state.recent_isotretinoin !== 'yes') return true;
  return product.recent_isotretinoin_safe;
}

function passesAllergyFilter(product) {
  if (!state.allergies.length) return true;

  const productAllergies = Array.isArray(product.allergies) ? product.allergies : [];

  if (!productAllergies.length) return true;

  return !state.allergies.some((allergy) => productAllergies.includes(allergy));
}

function passesSkinProfileFilter(product) {
  if (!state.skin_profile) return true;
  if (!product.skin_profile || !product.skin_profile.length) return true;
  return product.skin_profile.includes(state.skin_profile);
}

function passesSkinSensitivityFilter(product) {
  if (!state.skin_sensitivity) return true;

const sensitivityRank = {
  not_sensitive: 1,
  moderately_sensitive: 3,
  very_sensitive: 4
};

  const selectedRank = sensitivityRank[state.skin_sensitivity];

 // Blank skin sensitivity = only safe for not sensitive users.
// For moderately or very sensitive users, play it safe and exclude.
if (!product.skin_sensitivity || !product.skin_sensitivity.length) {
  return selectedRank && selectedRank <= 1;
}

  if (!selectedRank) {
    return product.skin_sensitivity.includes(state.skin_sensitivity);
  }

  return product.skin_sensitivity.some((value) => {
    const productRank = sensitivityRank[value];
    return productRank && productRank >= selectedRank;
  });
}
function activeSafetyGroup(value) {
  const active = normalizeValue(value);

  if ([
    'retinol',
    'retinoid',
    'retinoids',
    'retinal',
    'retinaldehyde',
    'retinyl_palmitate',
'retinyl_retinoate',
'retinyl_acetate',
'retinyl_propionate',
'granactive_retinoid',
'hydroxypinacolone_retinoate',
'hpr',
'retinsphere_technology',
    'tretinoin',
    'adapalene',
    'tazarotene',
    'tretinoin_adapalene_tazarotene'
  ].includes(active)) {
    return 'retinoids';
  }

  if ([
    'glycolic_ahas',
    'glycolic_acid_ahas',
    'glycolic_acid',
    'aha',
    'ahas',
    'lactic_acid',
    'mandelic_acid'
  ].includes(active)) {
    return 'ahas';
  }

  if ([
    'salicylic_acid',
    'salicylic_acid_bha',
    'bha',
    'bhas',
    'lipohydroxy_acid_lha',
    'lha'
  ].includes(active)) {
    return 'bhas';
  }

   if ([
    'roaccutane_isotretinoin',
    'isotretinoin',
    'roaccutane',
    'accutane',
    'isotretinoin_accutane_roaccutane',
    'roaccutane_accutane',
    'accutane_roaccutane'
  ].includes(active)) {
    return 'isotretinoin';
  }

  if ([
    'oral_antibiotics_doxycycline_minocycline',
    'doxycycline',
    'minocycline',
    'oral_antibiotics'
  ].includes(active)) {
    return 'oral_antibiotics';
  }

  if ([
    'vitamin_c',
    'l_ascorbic_acid',
    'ascorbic_acid'
  ].includes(active)) {
    return 'vitamin_c';
  }

  return active;
}

function toActiveSafetyGroups(values) {
  return new Set(splitListValues(values).map(activeSafetyGroup).filter(Boolean));
}

function passesCurrentActivesFilter(product) {
  if (!state.current_actives.length) return true;

  const selectedGroups = toActiveSafetyGroups(state.current_actives);
  const productGroups = toActiveSafetyGroups(product.active_ingredients || []);
  const notSafeGroups = toActiveSafetyGroups(product.not_safe_to_layer_with || []);

  for (const group of selectedGroups) {
    // Do not recommend another product from the same active family
    // the customer already says they are using.
    if (productGroups.has(group)) {
      return false;
    }

    // Do not recommend products explicitly marked as unsafe to layer
    // with the customer's selected active/medication.
    if (notSafeGroups.has(group)) {
      return false;
    }
  }

  return true;
}
function productMatchesSelectedConcern(product) {
  if (!state.concern) return true;

  if (product.main_concern === state.concern) return true;

  if (
    product.secondary_concerns &&
    product.secondary_concerns.includes(state.concern)
  ) {
    return true;
  }

  return false;
}

function passesMainConcernFilter(product) {
  // Makeup should not be filtered by skin concern.
  // It is matched by makeup category instead: mascara, palette, foundation, lip gloss, etc.
  if (
    product.slot === 'makeup' ||
    normalizeValue(product.product_type_meta) === 'makeup'
  ) {
    return true;
  }

  return productMatchesSelectedConcern(product);
}
function calculateProductScore(product) {
  let score = 0;

  if (product.main_concern === state.concern) {
  score += 80;
} else if (
  product.secondary_concerns &&
  product.secondary_concerns.includes(state.concern)
) {
  score += 35;
}
  if (product.skin_profile.includes(state.skin_profile)) score += 50;
  if (product.skin_sensitivity.includes(state.skin_sensitivity)) score += 30;
  if (product.fitzpatrick && product.fitzpatrick.includes(state.fitzpatrick)) score += 10;
  if (matchRoutinePreference(product.routine_preference, state.routine_preference)) score += 20;

  const hasPreferredBrandFilter =
    Array.isArray(state.preferred_brands) &&
    !state.preferred_brands.includes('any') &&
    state.preferred_brands.length > 0;

  if (hasPreferredBrandFilter && state.preferred_brands.includes(product.vendor_slug)) {
    score += 140;
  } else if (!hasPreferredBrandFilter) {
    score += 5;
  }



  if (product.available) score += 10;

  if (product.vendor_slug === 'mustela') {
    if (state.age === '0-12') {
      score += 300;
    } else {
      score -= 60;
    }
  }

  if (
    state.age === '0-12' &&
    state.skin_profile === 'dry' &&
    PAEDIATRIC_DRY_BOOST_RE.test(product.title || '')
  ) {
    score += 40;
  }

    if (
    state.concern === normalizeValue('Pigmentation / Melasma / Dark Marks') &&
    product.vendor_slug === 'la_roche_posay' &&
    /\bmela[-\s]?b[-\s]?3\b|\bmelasyl\b/i.test(product.title || '')
  ) {
    score += 70;
  }

  return score;
}

function applyHardFilters(list) {
  return list
    .filter((product) => product.available)
    .filter((product) => matchRoutinePreference(product.routine_preference, state.routine_preference))
    .filter(passesFitzpatrickFilter)
    .filter(passesAgeFilter)
    .filter(passesTreatmentFilter)
    .filter(passesTopicalSteroidFilter)
    .filter(passesIsotretinoinFilter)
    .filter(passesAllergyFilter)
    .filter(passesCurrentActivesFilter)
    .filter(passesSkinSensitivityFilter);
}
function buildCurrentPlan() {
  const plans = state.age === '0-12' ? SLOT_PLANS_PAEDIATRIC : SLOT_PLANS;
  const base = plans[state.routine_preference] || plans.am_plus_pm;
  let plan = base.slice();

  // Budget must not remove routine steps.
  // It only changes product ordering later.
  if (state.age === '0-12' && state.skin_profile === 'dry') {
    const balmStep = { slot: 'balm', step: 'Soothe', label: 'Balm' };
    const alreadyHasBalm = plan.some((step) => step.slot === 'balm');
    const sunscreenIdx = plan.findIndex((step) => step.slot === 'sunscreen');

    if (!alreadyHasBalm) {
      if (sunscreenIdx >= 0) {
        plan.splice(sunscreenIdx, 0, balmStep);
      } else {
        plan.push(balmStep);
      }
    }
  }

const wantsMakeup = state.include_makeup === 'yes' &&
    state.age !== '0-12' &&
    state.age !== '13-17' &&
    (state.routine_preference === 'am_only' || state.routine_preference === 'am_plus_pm');

  if (wantsMakeup) {
    plan.push({ slot: 'makeup_1', step: 'Makeup', label: 'Mascara' });
    plan.push({ slot: 'makeup_2', step: 'Makeup', label: 'Palette' });
    plan.push({ slot: 'makeup_3', step: 'Makeup', label: 'Color Balm' });
    plan.push({ slot: 'makeup_4', step: 'Makeup', label: 'Foundation' });
    plan.push({ slot: 'makeup_5', step: 'Makeup', label: 'Lip Gloss' });
    plan.push({ slot: 'makeup_6', step: 'Makeup', label: 'Setting Spray' });
  }

  return plan;
}
function compareRoutineCandidates(a, b) {
  const aScore = calculateProductScore(a);
  const bScore = calculateProductScore(b);
  const scoreDiff = bScore - aScore;

  const aPrice = Number(a.price_cents || 0);
  const bPrice = Number(b.price_cents || 0);
  const priceDiff = aPrice - bPrice;

  // Protect recommendation quality:
  // a much better match should still beat a cheaper weaker match.
  const qualityGuardrail = 35;

  if (state.budget === 'under_700') {
    if (Math.abs(scoreDiff) > qualityGuardrail) return scoreDiff;
    if (priceDiff !== 0) return priceDiff;
    return scoreDiff;
  }

  if (state.budget === '700_2000') {
    // Balanced budget: only use price as a tie-breaker / near-tie breaker.
    if (Math.abs(scoreDiff) <= 15 && priceDiff !== 0) return priceDiff;
    return scoreDiff || priceDiff;
  }

  // Over R2,000 / no tight budget: best match first.
  return scoreDiff || priceDiff;
}
function candidatesForSlotFromProducts(slot, { strict, products }) {
  if (!Array.isArray(products)) return [];

  const effectiveSlot = slot && slot.startsWith('makeup') ? 'makeup'
    : slot === 'balm' ? 'moisturiser'
    : slot;

  let list = products.filter((product) =>
  product.slot === effectiveSlot ||
  (slot === 'night_cream' && product.slot === 'moisturiser')
);

  if (slot && MAKEUP_SLOT_CATEGORY[slot]) {
    const wantedCategory = MAKEUP_SLOT_CATEGORY[slot];
    list = list.filter((p) => p.makeup_category === wantedCategory);
  }

  if (slot === 'balm') {
    list = list.filter((p) => PAEDIATRIC_BALM_RE.test(p.title || ''));
  }

  if (slot === 'moisturiser' && state.age === '0-12' && state.skin_profile === 'dry') {
    const filtered = list.filter((p) => !PAEDIATRIC_BALM_RE.test(p.title || ''));
    if (filtered.length) list = filtered;
  }

  list = applyHardFilters(list);


if (strict && slot !== 'sunscreen') {
  list = list.filter(passesMainConcernFilter);
}

  return collapseRoutineFamilies(
  list.sort(compareRoutineCandidates)
);
}

function applyBrandClustering(plan, picks, lockedSlots, getCandidates) {
  const locked = lockedSlots instanceof Set ? lockedSlots : new Set();
  const getSlotCandidates = typeof getCandidates === 'function' ? getCandidates : () => [];

  const brandCounts = new Map();

  for (const step of plan) {
    const p = picks[step.slot];
    if (!p || !p.vendor_slug) continue;
    brandCounts.set(p.vendor_slug, (brandCounts.get(p.vendor_slug) || 0) + 1);
  }

  const maxCount = Math.max(0, ...brandCounts.values());
  if (maxCount >= 2) return;

  let bestSwap = null;

  for (const step of plan) {
    if (locked.has(step.slot)) continue;

    const current = picks[step.slot];
    if (!current) continue;

    const currentScore = calculateProductScore(current);
    const strictCandidates = getSlotCandidates(step.slot, { strict: true });
    const candidates = strictCandidates.length
      ? strictCandidates
      : getSlotCandidates(step.slot, { strict: false });

    const otherUsed = new Set();

    for (const other of plan) {
      if (other.slot === step.slot) continue;
      const op = picks[other.slot];
      if (op) otherUsed.add(op.handle);
    }

    for (const candidate of candidates) {
      if (candidate.handle === current.handle) continue;
      if (otherUsed.has(candidate.handle)) continue;
      if (!candidate.vendor_slug) continue;
      if ((brandCounts.get(candidate.vendor_slug) || 0) < 1) continue;
      if (candidate.vendor_slug === current.vendor_slug) continue;

      const candidateScore = calculateProductScore(candidate);
      const scoreLoss = currentScore - candidateScore;

      if (scoreLoss > CLUSTER_SCORE_LOSS) continue;

      if (!bestSwap || scoreLoss < bestSwap.scoreLoss) {
        bestSwap = { slot: step.slot, candidate, scoreLoss };
      }
    }
  }

  if (bestSwap) {
    picks[bestSwap.slot] = bestSwap.candidate;
  }
}
function diversifyForVariation(plan, picks, cap, lockedSlots, variationIndex, slotCandidates) {
  if (variationIndex === 0) return;

  const locked = lockedSlots instanceof Set ? lockedSlots : new Set();
  const candidatesBySlot = slotCandidates || {};

  let total = plan.reduce((sum, step) => sum + (picks[step.slot]?.price_cents || 0), 0);

  const effectiveCap = cap === null || cap === undefined
    ? Infinity
    : Math.max(cap, total);

  for (const step of plan) {
    if (locked.has(step.slot)) continue;

    const current = picks[step.slot];
    if (!current) continue;

    const pool = candidatesBySlot[step.slot] || [];
    if (pool.length < 2) continue;

    const otherUsed = new Set();

    for (const other of plan) {
      if (other.slot === step.slot) continue;
      const p = picks[other.slot];
      if (p) otherUsed.add(p.handle);
    }

    const slack = effectiveCap - (total - (current.price_cents || 0));

    const alts = pool.filter((candidate) =>
      candidate.handle !== current.handle &&
      !otherUsed.has(candidate.handle) &&
      (candidate.price_cents || 0) <= slack
    );

    if (!alts.length) continue;

    const pick = alts[(variationIndex - 1) % alts.length];

    total = total - (current.price_cents || 0) + (pick.price_cents || 0);
    picks[step.slot] = pick;
  }
}
const MAKEUP_DIAGNOSTIC_FILTERS = [
  {
    fn: (product) => matchRoutinePreference(product.routine_preference, state.routine_preference),
    label: 'routine preference (AM / PM)'
  },
  { fn: passesFitzpatrickFilter, label: 'Fitzpatrick type' },
  { fn: passesAgeFilter, label: 'age range' },
  { fn: passesTreatmentFilter, label: 'recent aesthetic treatments' },
  { fn: passesTopicalSteroidFilter, label: 'topical-steroid use' },
  { fn: passesIsotretinoinFilter, label: 'isotretinoin use' },
{ fn: passesAllergyFilter, label: 'allergies' },
{ fn: passesCurrentActivesFilter, label: 'actives or medications' },
{ fn: passesSkinProfileFilter, label: 'skin profile' },
  { fn: passesSkinSensitivityFilter, label: 'skin sensitivity' }
];

function findUnblockingFiltersForMakeup(pool) {
  const unblockers = [];

  for (const filter of MAKEUP_DIAGNOSTIC_FILTERS) {
    const withoutThis = pool.filter((product) =>
      MAKEUP_DIAGNOSTIC_FILTERS.every((group) => group === filter || group.fn(product))
    );

    if (withoutThis.length > 0) unblockers.push(filter.label);
  }

  return unblockers;
}

function diagnoseMakeupEmptyFromProducts(products) {
  const allMakeup = products.filter((product) => product.slot === 'makeup');
  if (!allMakeup.length) return { kind: 'no_catalog' };

const hasBrandFilter =
  Array.isArray(state.preferred_brands) &&
  state.preferred_brands.length > 0 &&
  !state.preferred_brands.includes('any');

const brandMatched = hasBrandFilter
  ? allMakeup.filter((product) => state.preferred_brands.includes(product.vendor_slug))
  : allMakeup;

const unfilteredPassesHard = hasBrandFilter && applyHardFilters(allMakeup).length > 0;

  if (hasBrandFilter && !brandMatched.length) {
    return { kind: 'brand_no_vendors', hasBrandFilter: true };
  }

  const brandAfterHard = applyHardFilters(brandMatched);

if (brandAfterHard.length > 0) {
  return {
    kind: 'no_subcategory_match',
    unblockers: [],
    hasBrandFilter,
    clearingBrandHelps: hasBrandFilter && unfilteredPassesHard
  };
}

  const unblockers = findUnblockingFiltersForMakeup(brandMatched);

  if (hasBrandFilter) {
    return {
      kind: 'other_filters',
      unblockers,
      hasBrandFilter: true,
      clearingBrandHelps: unfilteredPassesHard
    };
  }

  return {
    kind: 'other_filters_no_brand',
    unblockers,
    hasBrandFilter: false,
    clearingBrandHelps: false
  };
}
console.log('[BuildMyRoutine] scoring loaded');
